import { render, staticRenderFns } from "./StudentScholarshipReport.vue?vue&type=template&id=6a329f74"
import script from "./StudentScholarshipReport.vue?vue&type=script&lang=js"
export * from "./StudentScholarshipReport.vue?vue&type=script&lang=js"
import style0 from "./StudentScholarshipReport.vue?vue&type=style&index=0&id=6a329f74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports